import { createTheme } from '@mui/material';
import { COLORS } from './colors';

const palette = {
  primary: {
    main: COLORS.BLUE,
    dark: COLORS.DARK_BLUE,
  },
  secondary: {
    main: COLORS.GREEN,
  },
  error: {
    main: COLORS.RED,
  },
};

export const theme = createTheme({
  palette,
});
